import { render, staticRenderFns } from "./BookBankEntityDetails.vue?vue&type=template&id=6f2bcf1a&scoped=true"
import script from "./BookBankEntityDetails.vue?vue&type=script&lang=js"
export * from "./BookBankEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./BookBankEntityDetails.vue?vue&type=style&index=0&id=6f2bcf1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2bcf1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2bcf1a')) {
      api.createRecord('6f2bcf1a', component.options)
    } else {
      api.reload('6f2bcf1a', component.options)
    }
    module.hot.accept("./BookBankEntityDetails.vue?vue&type=template&id=6f2bcf1a&scoped=true", function () {
      api.rerender('6f2bcf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BookBankEntityDetails.vue"
export default component.exports